import { observer } from 'mobx-react-lite';

import { DatePicker } from '@components/datepicker';
import { FormLabel } from '@components/form-label';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';

import { configs } from 'jobboards/configs';
import { useStore } from 'models/Provider';

export const PromoteJobDotIsForm = observer((props) => {
  const { t, lang } = useStore();
  const { boardState } = props;

  return (
    <>
      <Stack space={6}>
        <Stack space={4}>
          <Stack space={1}>
            <FormLabel text="Birtingardagur" />
            <DatePicker
              lang="is"
              value={boardState.startDate}
              onChange={(val) => boardState.setTextField('startDate', val)}
            />
          </Stack>

          <TextField
            label="Netfang tengiliðs"
            value={boardState.contactEmail}
            onChange={(val) => boardState.setTextField('contactEmail', val)}
          />
        </Stack>

        <Text font="bold16" text="Fyrirtækið" />

        <Stack space={4}>
          <TextField
            label="Slagorð"
            value={boardState.slogan}
            onChange={(val) => boardState.setTextField('slogan', val)}
          />
          <TextField
            label="Staðsetning"
            value={boardState.location}
            onChange={(val) => boardState.setTextField('location', val)}
          />
          <TextField
            label="Netfang"
            value={boardState.companyEmail}
            onChange={(val) => boardState.setTextField('companyEmail', val)}
          />
          <TextField
            label="Facebook"
            value={boardState.facebook}
            onChange={(val) => boardState.setTextField('facebook', val)}
          />
          <TextField
            label="Twitter"
            value={boardState.twitter}
            onChange={(val) => boardState.setTextField('twitter', val)}
          />
          <TextField
            label="Linkedin"
            value={boardState.linkedin}
            onChange={(val) => boardState.setTextField('linkedin', val)}
          />
        </Stack>

        <Separator />
        <FormLabel text={t('jobboards.jobdotis.info')} />
        <Text text={configs.job_dot_is[lang].priceText} />
        <Separator />
      </Stack>
    </>
  );
});
